// Phone-only: "Klientide arvustused" cards form two staggered columns where each next card
// goes into the column that is currently shorter, so there is no big gap under a short card.
//
// CSS grid with 4px rows: every card gets `grid-row-end: span N` (N from its height) and the
// grid auto-places it in the first free slot. Nothing is moved in the DOM, so the sorting and
// the "Näita rohkem" button in assets/reviews-box.js keep working; this script only reacts to
// what they change (hidden cards, reordering). Without JS the CSS falls back to plain rows.
(() => {
  const phone = window.matchMedia('(max-width: 749px)');
  const ROW = 4; // px, same as grid-auto-rows in assets/trop-mobile.css
  const GAP = 34; // px between stacked cards

  const lists = [...document.querySelectorAll('.reviews-box__list')];
  if (!lists.length) return;

  const layout = (list) => {
    const cards = [...list.querySelectorAll(':scope > .reviews-box__review')];
    if (!phone.matches) {
      list.classList.remove('is-masonry');
      for (const card of cards) card.style.removeProperty('grid-row-end');
      return;
    }
    list.classList.add('is-masonry');
    const visible = cards.filter((card) => !card.hidden);
    // Measuring needs every card at its natural height, which briefly makes the grid much
    // shorter. The list keeps its current height meanwhile, otherwise the page gets shorter
    // for a moment and the browser pulls the scroll position up ("Näita rohkem" jumped back up).
    const keepHeight = list.getBoundingClientRect().height;
    list.style.minHeight = `${keepHeight}px`;
    // Natural heights first (a card is content-sized: align-items is start).
    for (const card of visible) card.style.gridRowEnd = 'auto';
    for (const card of visible) {
      const margin = parseFloat(getComputedStyle(card).marginTop) || 0;
      const height = card.getBoundingClientRect().height + margin + GAP;
      card.style.gridRowEnd = `span ${Math.ceil(height / ROW)}`;
    }
    list.style.minHeight = '';
  };

  for (const list of lists) {
    let frame = 0;
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => layout(list));
    };

    new MutationObserver(schedule).observe(list, {
      childList: true,
      subtree: false,
      attributes: true,
      attributeFilter: ['hidden'],
      attributeOldValue: false,
    });
    // `hidden` is set on the cards themselves, not on the list.
    new MutationObserver(schedule).observe(list, { subtree: true, attributes: true, attributeFilter: ['hidden'] });

    if ('ResizeObserver' in window) {
      const resize = new ResizeObserver(schedule);
      resize.observe(list);
    }
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    phone.addEventListener('change', schedule);
    schedule();
  }
})();
